import { Grid2, Box, Typography, IconButton } from "@mui/material"
import { useState } from "react"
import Styles from "./Web.module.css"
import Sunil from "../../../ui-utils/latestPics/Sunil.jpg"
import Laxmi from "../../../ui-utils/latestPics/Laxmi.jpg"
import Anil from "../../../ui-utils/latestPics/Anil.jpg"
import en from "../../../i18n/English/Aboutus/department.json";
import hi from "../../../i18n/Hindi/Aboutus/department.json";
import kn from "../../../i18n/Kannada/Aboutus/department.json";
import ma from "../../../i18n/Marathi/Aboutus/department.json";
import gu from "../../../i18n/Gujarati/Aboutus/department.json";
import { useLanguage } from "../../../Context/LangContext";
export default function Web() {
         const { language } = useLanguage();
         const translations = { en, hi, kn,gu,ma };
       const t = translations[language] || translations.en ;
    return (
        <>

            <Grid2 className={Styles.outerCard}>
                <Grid2 className={Styles.title_card}>
                    {/* <h1 className={Styles.leader_title}>{t.title}</h1> */}
                    <div className={Styles.headingContainer}>
                        <div className={Styles.gradientBackground}></div>
                        <h1 className={Styles.leader_title} style={{ fontWeight: 600 }}>
                            {t.title}
                        </h1>
                    </div>
                </Grid2>



                <Grid2 className={Styles.inner_card}>


                    <Grid2 className={Styles.flip_card}>
                        <Grid2 className={Styles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={Styles.flip_card_front}>
                                <img src={Sunil} alt="leaderpic" className={Styles.picture} />
                                <Typography className={Styles.ex_subtit}>{t.members[0].name}</Typography>
                                <Typography>{t.members[0].designation}</Typography>
                                {/* <Typography  className={`${Styles.ex_subtit2}`}>
                                    Mr. Shetty is a seasoned professional,
                                    possessing over more than four decades of
                                    experience in the Indian Stock Market as well
                                    as Financial Markets.
                                </Typography> */}
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={Styles.flip_card_back}>
                                <Typography className={Styles.ex_subtitback}>{t.members[0].name}</Typography>
                                <Typography className={Styles.ex_subtit1back}>{t.members[0].designation}</Typography>
                                <Typography className={Styles.ex_subtit2}>

                                    <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[0].name},</span>
                                    {t.members[0].description}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    {/* Card 2 */}
                    <Grid2 className={Styles.flip_card}>
                        <Grid2 className={Styles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={Styles.flip_card_front}>
                                <img src={Anil} alt="leaderpic" className={Styles.picture} />
                                <Typography className={Styles.ex_subtit}>{t.members[1].name}</Typography>
                                <Typography>{t.members[1].designation}</Typography>
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={Styles.flip_card_back}>
                                <Typography className={Styles.ex_subtitback}>{t.members[1].name}</Typography>
                                <Typography className={Styles.ex_subtit1back}>{t.members[1].designation}</Typography>
                                <Typography className={Styles.ex_subtit2} >
                                    <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[1].name},</span> {t.members[1].description}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    {/* Card 3 */}
                    <Grid2 className={Styles.flip_card}>
                        <Grid2 className={Styles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={Styles.flip_card_front}>
                                <img src={Laxmi} alt="leaderpic" className={Styles.picture} />
                                <Typography className={Styles.ex_subtit}>{t.members[2].name}</Typography>
                                <Typography className={Styles.ex_subtit1}>{t.members[2].designation}</Typography>
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={Styles.flip_card_back}>
                                <Typography className={Styles.ex_subtitback}>{t.members[2].name}</Typography>
                                <Typography className={Styles.ex_subtit1back}>{t.members[2].designation}</Typography>
                                <Typography className={Styles.ex_subtit2} >
                                    <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[2].name},</span>{t.members[2].description}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>


                </Grid2>

            </Grid2>

        </>
    )
}